import request from "@/router/request";

/**查询基础信息 */
export const QueryBasicInfo = (IdNo) => {
    return request({
        url: '/api/HousingFundBusiness/QueryBasicInfo',
        method: "get",
        params: {
            IdNo
        }
    });
}

/**查询明细信息 */
export const QueryDetailInfo = (query) => {
    return request({
        url: '/api/HousingFundBusiness/QueryDetailInfo',
        method: "get",
        params: query
    });
}